module.exports = __webpack_public_path__ + "static/media/glass.5be12087.svg";